import type { StorageItem } from '@octopus-do/octopus-editor'
import type { WithId } from '@octopus-do/octopus-project-core'
import { migrationUiSelector } from '@store/migrationSelectors/uiSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { noop } from '@/helpers'
import { useArtBoardDisabled } from '@/hooks/selectors/useArtBoardDisabled'
import { PureBlockEditor } from '../PureBlockEditor'
import { useMonolithicData, useUpdateContent } from './hooks'

interface Props extends WithId {
  onUpload: (files: FileList) => Promise<StorageItem[]>
  readonly: boolean
}

export const MonolithicEditor: React.FC<Props> = ({
  id,
  onUpload,
  readonly,
}) => {
  const { color, content, title } = useMonolithicData(id)

  const { onChange, onRename } = useUpdateContent(id)

  const locked = useSelector(migrationUiSelector.getLocks(id))

  // The artboard is off and nothing typed here would be saved: the editor
  // closes with it instead of taking text that is gone on the next load.
  const artboardDisabled = useArtBoardDisabled()

  return (
    <PureBlockEditor
      key={id}
      onFocus={noop}
      onBlur={noop}
      color={color}
      onChange={onChange}
      onUpload={onUpload}
      onRename={onRename}
      content={content}
      title={title}
      readonly={readonly || artboardDisabled}
      locked={Boolean(locked)}
    />
  )
}
